import * as socketEvent from './socketEvent.js'
import * as socketMessage from './socketMessage.js'
import AppConfig from '../../config/AppConfig.js'
import {getLoginId} from '../functions/Common.js'
import {pushInit} from './socketEventSender.js'

let socket = "";
let vthis = ""
let intervalPing = null
let pingTime = 10000

export default function init(_this){
  if(_this !== undefined){
    vthis = _this
  }
  if(typeof(WebSocket) === "undefined"){
      alert("您的浏览器不支持socket")
  }else{
      // 实例化socket
      socket = new WebSocket(AppConfig.socketUrl)
      // 监听socket连接
      socket.onopen = onopen
      // 监听socket错误信息
      socket.onerror = onerror
      // 监听socket消息
      socket.onmessage = onmessage
      // 监听socket关闭
      socket.onclose = onclose
      // 返回连接
      if(vthis !== ''){
		window.SocketConnect = socket
      }
      // 触发心跳
      sendPing()
  }
}

// socket打开
function onopen(){
	pushInit()
	console.log("socket 链接成功")
}

// socket异常
function onerror(){
  console.log("socket 异常")
  clearInterval(intervalPing)
  socket.close()
}

// socket获得消息
function onmessage(msg){
	// 判断是否可以db是否可以被锁
	if(window.chatDbLock !== undefined && window.chatDbLock === true){
		return
	}
	// 判断是否已登录，未登录，不处理任何消息
	if(getLoginId() == 0){
		return
	}
	let data = JSON.parse(msg.data)
	// console.log(data)
	if(data.type !== undefined && data.bean !== undefined && data.bean.type !== undefined){
		let bean = data.bean
		try{
			// 处理消息响应-事件类型
			if(data.type == 'event'){
			  socketEvent[bean.type](bean,vthis,socket)
			}
			// 处理消息响应-消息类型
			else if(data.type == 'message'){
				socketMessage[bean.type](bean,vthis,socket)
			}
		}catch(e){
			// console.error('socket onmessage异常，bean.type：'+bean.type+',错误消息：'+e.message)
			// 未处理的事件类型，统一这里处理
			vthis.$store.commit('updateOtherEvent',bean)
		}
	}
}

// socket关闭
function onclose(){
  console.log("socket已经关闭")
  clearInterval(intervalPing)
  if(socket.readyState == 3){
    init()
  }
}

// 发送心跳包
function sendPing() {
  intervalPing = setInterval(() => {
    if(socket.readyState == 1){
		let pingData = {
		  type:'dongdong',
		  adminId:getLoginId()
		}
		socket.send(JSON.stringify(pingData))
    }
  }, pingTime)
}
